import Loader from './loader.jsx';
import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBBtn,
  MDBInput,
} from 'mdb-react-ui-kit';

export default function BookDetailsPopUp(props){
    const { show, setShow, book, statusId, errorId, addSuggestion, suggested} = props;
    
    function handleAddToSuggestions(){
        addSuggestion(book);
        setShow(false);
    }
    return <MDBModal open={show} setOpen={setShow} tabIndex="-1">
        <MDBModalDialog centered={true} size="md"> 
            <MDBModalContent className="p-4 rounded-lg shadow-lg">
                <MDBModalHeader>
                    <MDBModalTitle className="font-semibold text-xl">More Book Info</MDBModalTitle>
                </MDBModalHeader>

                <MDBModalBody className="space-y-4 mt-4">
                 
                {statusId === "pending" && (
                <div className="flex justify-center items-center">
                    <div className='flex justify-center items-center'>
                        <Loader />
                    </div>
                </div>                
                )}
                {statusId === "rejected" && (
                <div className='flex justify-center items-center'>
                    <h2 className="text-amber-900 mb-2">Error loading book details: {errorId}</h2>
                </div>
                )}
                {(statusId === "fulfilled" || statusId === "suggested") && book && (
                <div className="flex flex-col items-center">
                    <img
                        src={book.bookImg}
                        alt={book.title}
                        className="w-32 h-48 object-cover"
                    />
                    <div>
                        <div className="mt-4 text-center">
                            <h3 className="text-amber-900 mb-2">{book.title}</h3>
                            <span className="text-amber-600 mb-2">by {book.author}</span>
                            <div className="flex gap-2 mb-3 justify-center">
                              <span className="px-2 py-1 bg-amber-100 text-amber-700 rounded text-xs">{book.genre}</span>
                              <span className="px-2 py-1 bg-amber-100 text-amber-700 rounded text-xs">{book.pages} pages</span>
                            </div>
                        </div>
                        <p className="text-amber-700">{book.description}</p>
                    </div>
                </div>
                )}
                </MDBModalBody>

                <MDBModalFooter className="flex gap-2 justify-end mt-6">
                        {suggested &&(
                            <span className='px-6 py-2 bg-gradient-to-r from-blue-500 to-cyan-600 text-white !rounded-lg opacity-50'>
                                This book is already in suggestions
                            </span>
                        )}
                        <button
                            onClick={() => setShow(false)}
                            className="px-4 py-2 border border-blue-200 text-blue-700 !rounded-lg hover:bg-blue-50 transition-colors"
                        >
                        Cancel
                        </button>
                        {!suggested &&(
                            <button
                            disabled={statusId !== "fulfilled" || !book}
                            onClick={handleAddToSuggestions}
                            className="px-6 py-2 bg-gradient-to-r from-blue-500 to-cyan-600 text-white !rounded-lg hover:from-blue-600 hover:to-cyan-700 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                        Add To Suggestions
                        </button>   
                        )}
                        
                        
                        
                </MDBModalFooter>
            </MDBModalContent>
        </MDBModalDialog>
    </MDBModal>

}